
import { computed, defineComponent, onMounted } from 'vue';
import wishListsStore from '../wish-lists.store';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import WishListsThumbView from '@/b2c/wishlists/ui/WishListsThumbView.vue';
import WishListsAddList from '@/b2c/wishlists/ui/WishListsAddList.vue';

export default defineComponent({
    name: 'WishLists',
    components: { WishListsThumbView, WishListsAddList },
    props: {
        detailsUrl: {
            type: String,
            required: true,
        },
    },
    setup() {
        const labels = useBlockLabels();

        const wishLists = computed(() => {
            return wishListsStore.lists;
        });

        onMounted(wishListsStore.updateLists.bind(wishListsStore));

        return {
            wishLists,
            labels,
        };
    },
});
